export enum CreatorPermission {
  PREVIEW = 'PREVIEW',
  EDIT = 'EDIT',
}
